import { Notice } from 'actions/actionTypes';

// 이벤트
export const changeNoticeSearchFilter = (type, name, value) => ({
    type: Notice.CHANGE_NOTICE_SEARCH_FILTER,
    payload: { type, name, value },
});

// 검색 필터 초기화
export const searchFilterReset = () => ({ type: Notice.SEARCH_FILTER_RESET });

// 공지사항 글 목록 조회
export const loadNoticeListRequest = () => ({
    type: Notice.LOAD_NOTICE_LIST_REQUEST,
});
export const loadNoticeListSuccess = (responseData) => ({
    type: Notice.LOAD_NOTICE_LIST_SUCCESS,
    payload: responseData,
});
export const loadNoticeListFailure = (errorMessage) => ({
    type: Notice.LOAD_NOTICE_LIST_FAILURE,
    payload: errorMessage,
});

// 공지사항 글 상세 조회
export const loadNoticeInfoRequest = (idx) => ({
    type: Notice.LOAD_NOTICE_INFO_REQUEST,
    payload: idx,
});
export const loadNoticeInfoSuccess = (responseData) => ({
    type: Notice.LOAD_NOTICE_INFO_SUCCESS,
    payload: responseData,
});
export const loadNoticeInfoFailure = (errorMessage) => ({
    type: Notice.LOAD_NOTICE_INFO_FAILURE,
    payload: errorMessage,
});
